/* eslint-disable react-refresh/only-export-components */
import React, { useState } from 'react';
import { Collapse, List, ListItemButton, useTheme } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import NavItem from './NavItem';
import { branchListSx } from './navStyles';
import { ListItemText, ListItemIcon } from '@mui/material';


const NavCollapse = ({ item, level, isOpen, onToggle }) => {
  const [localOpen, setLocalOpen] = useState(false);
  const indent = `${level * 24}px`;
  const theme = useTheme();

  // Use controlled state if isOpen and onToggle are provided (top-level branches)
  // Otherwise use local state (nested branches)
  const open = isOpen !== undefined ? isOpen : localOpen;
  const handleClick = () => {
    if (onToggle) {
      onToggle();
    } else {
      setLocalOpen(!localOpen);
    }
  };

  return (
    <>
      <ListItemButton onClick={handleClick} sx={listItemButtonStyles(theme, open, indent)}>
        {open ? <ExpandLess sx={{ color: theme.palette.text.default }} /> : <ExpandMore sx={{ color: theme.palette.text.default }} />}
        <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' }}>
          <ListItemText primary={item.title} sx={{ flexGrow: 1, paddingRight: indent, color: theme.palette.text.default }}/>
          <ListItemIcon sx={{ color: theme.palette.text.default }}>{item.icon}</ListItemIcon>
        </div>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" dense disablePadding sx={branchListSx(theme)}>
          {item.children.map((childItem) => (
            childItem.children
              ? <NavCollapse key={childItem.id} item={childItem} level={level + 1} />
              : <NavItem key={childItem.id} item={childItem} level={level + 1} open={open} />
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default NavCollapse;

export const listItemButtonStyles = (theme, open, indent) => ({
  borderRadius: '.8rem',
  height: '3rem',
  py: '0.5rem',
  backgroundColor: open ? theme.palette.button.active : 'inherit',
  '&:hover': {
    backgroundColor: theme.palette.button.active,
    '& .MuiListItemText-root': {
      color: theme.palette.text.active,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.text.active,
    },
  },
  '& .MuiListItemIcon-root, & .MuiSvgIcon-root': {
    color: open ? theme.palette.text.active : theme.palette.text.default,
  },
  pr: '1rem',
  '& .MuiListItemIcon-root': {
    minWidth: '0px',
    marginLeft: '0px'
  },
  '& .MuiListItemText-root': {
    margin: '0px',
    color: open ? theme.palette.text.active : theme.palette.text.default,
    fontWeight: open ? 'bold' : 'normal',
  },
  '& .MuiListItemText-primary': {
    fontWeight: open ? 'bold' : 'normal',
    color: open ? theme.palette.text.active : theme.palette.text.default,
  },
  display: 'flex',
  flexDirection: 'row-reverse',
  justifyContent: 'space-between',
  alignItems: 'center'
});